module.exports = __webpack_public_path__ + "img/icon6.504deba3.png";